module.exports = __webpack_public_path__ + "assets/img/help_image04-2@2x.3343fd1c.png";